// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Link,
  Text,
  Th,
  Thead,
  Tr,
  Textarea,
  Button,
  Select,
  Td,
  Icon,
  Input,
  useDisclosure,
  Modal,
  ModalOverlay,
  FormControl,
  FormLabel,
  Badge,
  FormErrorMessage,
  Grid,
  FormHelperText,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useColorMode,
  useColorModeValue,
  Box,
  Image
} from "@chakra-ui/react";

import { Scrollbars } from "react-custom-scrollbars";
import allFiles from "api/filemanager/all-files";
import config from "config/index";
// Custom components
import Card from "components/Card/Card.js";
import NiceButton from "components/NiceButton/NiceButton.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import PopupsTable from "components/Tables/PopupsTable";
import React, { useEffect, useState, useCallback } from "react";
import allPopup from "api/popup/all-popup";
import createPopup from "api/popup/create-popup";
import editPopup from "api/popup/edit-popup";
import { ToastContainer, toast } from 'react-toastify';
var moment = require('moment-jalaali')

import IconBox from "components/Icons/IconBox";
import { RiGhostLine, RiPlantLine } from "react-icons/ri";
import { useParams } from "react-router-dom";
import { RiLayoutTop2Fill } from "react-icons/ri";
import removePopup from "api/popup/remove-popup";
import allTours from "api/tours/all-tours";
import { PopupList } from "components/PopupList/PopupList";
import { PopupGallery } from "components/PopupGallery/PopupGallery";
import { useDropzone } from 'react-dropzone';
import uploadFile from "api/filemanager/upload-file";

function Popups() {
  const { address, tourname } = useParams()
  const [options, setOptions] = useState(false);
  const { colorMode } = useColorMode();
  const iconBlue = useColorModeValue("gray.100", "navy.700");
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  
  // استفاده از Link از Chakra UI
  const ChakraLink = Link;
  const [isLoading, setIsLoading] = useState(false);
  const [tablesTableData, setTablesTableData] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure()
  const [reload, setReload] = useState(false);
  const [title, setTitle] = useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const [popupType, setPopupType] = useState("content-text");
  const titleColor = useColorModeValue("gray.700", "white");
  const [files, setFiles] = useState("");
  const [popupInput, setPopupInput] = useState({})
  const [tours, setTours] = useState()
  const [selectedTour, setSelectedTour] = useState("")
  const [editingPopup, setEditingPopup] = useState(null)
  const [uploadingImage, setUploadingImage] = useState(false)
  const [uploadingVideo, setUploadingVideo] = useState(false)
  const [uploadingSound, setUploadingSound] = useState(false)
  const [types, setTypes] = useState([
    {
      title: "گالری تصاویر",
      value: "gallery",
    },
    {
      title: "لیست",
      value: "list",
    },
    {
      title: "قالب خطی (آی فریم)",
      value: "iframe",
    },
    {
      title: "گوگل فرم",
      value: "googleform",
    },
    {
      title: "صدا",
      value: "content-sound",
    },
    {
      title: "تصویر",
      value: "content-image",
    },
    {
      title: "ویدیو",
      value: "content-video",
    },
    {
      title: "متن",
      value: "content-text",
    }])
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true)
    allPopup(address).then((result) => {
      let items = []
      result.data.map((item) => {
        items.push({ value: "#" + item._id, label: item.title, address: item.address })

      })
     // items.push({ value: "new", label: "-- ساخت پاپ‌آپ جدید --", address: "total" })
      setOptions(items)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsLoading(false)
    })
  }, [])
  useEffect(() => {
    allFiles().then((result) => {
      let files = result.data.reverse()
      setFiles(files)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [])
  //if (!address) {
    useEffect(() => {
      allTours().then((result) => {
        let data = result.data.reverse()
        setTours(data)
      }).catch((err) => {
        console.error(err)
        if (err?.response?.data?.message?.pr)
          return toast.error(err?.response?.data?.message?.pr, {
            position: "bottom-right"
          })
        else
          return toast.error("خطایی رخ داده است.", {
            position: "bottom-right"
          })
      }).finally(() => {
      })
    }, [])
  /*} else {
    useEffect(() => {
      setSelectedTour(address)
    }, [])
  }*/
  function Delete() {
    setIsDeleteLoading(true)
    removePopup(selectedRow.address, selectedRow._id).then((result) => {
      setReload(!reload)
      onDeleteClose()
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsDeleteLoading(false)
    })
  }
  useEffect(() => {
    setIsLoading(true)
    allPopup(address).then((result) => {
      setTablesTableData(result.data.reverse())
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsLoading(false)
    })
  }, [reload])
  function createPopupAction() {
    console.log(popupInput)
    if (title == "")
      return toast.error("عنوان را وارد کنید.", {
        position: "bottom-right"
      })
    let type = popupType.split("-")[0]
    let data = {}
    if (type == 'content' && popupType.split("-")[1] == "image") {
      data.text = popupInput["image-text"]
      data.link = {
        title: popupInput["image-title"],
        href: popupInput["image-link"],
      }
      data.image = {
        href: popupInput["image-file"]?.replace("upload/user/", "/assets/users/"),
        alt: popupInput["image-alt"]
      }
    } else if (type == 'content' && popupType.split("-")[1] == "video") {
      data.text = popupInput["video-text"]
      data.link = {
        title: popupInput["video-title"],
        href: popupInput["video-link"],
      }
      data.video = popupInput["video-file"]?.replace("upload/user/", "/assets/users/")
    } else if (type == 'content' && popupType.split("-")[1] == "sound") {
      data.text = popupInput["sound-text"]
      data.link = {
        title: popupInput["sound-title"],
        href: popupInput["sound-link"],
      }
      data.audio = popupInput["sound-file"]?.replace("upload/user/", "/assets/users/")
    } else if (type == 'content' && popupType.split("-")[1] == "text") {
      data.text = popupInput["text-text"]
      data.link = {
        title: popupInput["text-title"],
        href: popupInput["text-link"],
      }
    } else if (type == 'iframe') {
      data.href = popupInput["iframe-href"]
      if (!(data.href?.startsWith("http://") || data.href?.startsWith("https://"))) {
        return toast.error("آدرس وارد شده نادرست است، باید با https:// یا http:// شروع شود.", {
          position: "bottom-right"
        })
      }
    } else if (type == 'googleform') {
      data.href = popupInput["googleform-href"]
      if (!(data.href?.startsWith("https://docs.google.com/forms/") || data.href?.startsWith("https://forms.gle/"))) {
        return toast.error("آدرس وارد شده نادرست است، باید با https://docs.google.com/forms/ یا https://forms.gle/ شروع شود.", {
          position: "bottom-right"
        })
      }
    } else if (type == 'list') {
      data.images = (popupInput["list"] || []).map((item) => {
        return {
          href: item.href?.replace("upload/user/", "/assets/users/"),
          caption: item.caption,
          file: item.file,
          target: item.target
        }
      })
    } else if (type == 'gallery') {
      data.images = (popupInput["gallery"] || []).map((item) => {
        return {
          href: item.href?.replace("upload/user/", "/assets/users/"),
          caption: item.caption,
          file: item.file,
        }
      })
    }

    setIsCreateLoading(true)
    if (editingPopup) {
      // ویرایش پاپ‌آپ
      editPopup(address, editingPopup._id, title, data).then((result) => {
        toast.success("پاپ‌آپ با موفقیت ویرایش شد.", {
          position: "bottom-right"
        })
        setReload(!reload);
        resetPopupForm()
        onClose()
      }).catch((err) => {
        console.error(err)
        if (err?.response?.status == 409)
          return toast.error("آدرس انتخابی تکراری است.", {
            position: "bottom-right"
          })
        else if (err?.response?.data?.message?.pr)
          return toast.error(err?.response?.data?.message?.pr, {
            position: "bottom-right"
          })
        else
          return toast.error("خطایی رخ داده است.", {
            position: "bottom-right"
          })
      }).finally(() => {
        setIsCreateLoading(false)
      })
    } else {
      // افزودن پاپ‌آپ جدید
      createPopup( title, type, data).then((result) => {
        toast.success("با موفقیت انجام شد.", {
          position: "bottom-right"
        })
        setReload(!reload);
        resetPopupForm()
        onClose()
      }).catch((err) => {
        console.error(err)
        if (err?.response?.status == 409)
          return toast.error("آدرس انتخابی تکراری است.", {
            position: "bottom-right"
          })
        else if (err?.response?.data?.message?.pr)
          return toast.error(err?.response?.data?.message?.pr, {
            position: "bottom-right"
          })
        else
          return toast.error("خطایی رخ داده است.", {
            position: "bottom-right"
          })
      }).finally(() => {
        setIsCreateLoading(false)
      })
    }
  }

  const resetPopupForm = () => {
    setTitle("")
    setPopupInput({})
    setPopupType("content-text")
    setEditingPopup(null)
  }

  const openEditPopup = (popup) => {
    if (!popup) return
    
    // تشخیص نوع پاپ‌آپ از روی داده‌ها اگر type فقط "content" باشه
    let popupTypeValue = popup.type || "content-text"
    
    // اگر type فقط "content" باشه، از روی data تشخیص بده
    if (popup.type == "content" || popup.type?.startsWith("content")) {
      if (popup.data?.image) {
        popupTypeValue = "content-image"
      } else if (popup.data?.video) {
        popupTypeValue = "content-video"
      } else if (popup.data?.audio) {
        popupTypeValue = "content-sound"
      } else {
        popupTypeValue = "content-text"
      }
    }
    
    // پر کردن فرم با اطلاعات پاپ‌آپ
    let inputData = {}
    
    if (popupTypeValue == "content-image") {
      inputData["image-text"] = popup.data?.text || ""
      inputData["image-title"] = popup.data?.link?.title || ""
      inputData["image-link"] = popup.data?.link?.href || ""
      inputData["image-file"] = popup.data?.image?.href?.replace("/assets/users/", "upload/user/") || ""
      inputData["image-alt"] = popup.data?.image?.alt || ""
    } else if (popupTypeValue == "content-video") {
      inputData["video-text"] = popup.data?.text || ""
      inputData["video-title"] = popup.data?.link?.title || ""
      inputData["video-link"] = popup.data?.link?.href || ""
      inputData["video-file"] = popup.data?.video?.replace("/assets/users/", "upload/user/") || ""
    } else if (popupTypeValue == "content-sound") {
      inputData["sound-text"] = popup.data?.text || ""
      inputData["sound-title"] = popup.data?.link?.title || ""
      inputData["sound-link"] = popup.data?.link?.href || ""
      inputData["sound-file"] = popup.data?.audio?.replace("/assets/users/", "upload/user/") || ""
    } else if (popupTypeValue == "content-text") {
      inputData["text-text"] = popup.data?.text || ""
      inputData["text-title"] = popup.data?.link?.title || ""
      inputData["text-link"] = popup.data?.link?.href || ""
    } else if (popupTypeValue == "iframe") {
      inputData["iframe-href"] = popup.data?.href || ""
    } else if (popupTypeValue == "googleform") {
      inputData["googleform-href"] = popup.data?.href || ""
    } else if (popupTypeValue == "list") {
      inputData["list"] = (popup.data?.images || []).map((item) => ({
        href: item.href?.replace("/assets/users/", "upload/user/") || "",
        caption: item.caption || "",
        file: item.file || "",
        target: item.target || "_parent"
      }))
    } else if (popupTypeValue == "gallery") {
      inputData["gallery"] = (popup.data?.images || []).map((item) => ({
        href: item.href?.replace("/assets/users/", "upload/user/") || "",
        caption: item.caption || "",
        file: item.file || ""
      }))
    }
    
    // تنظیم همه state ها به صورت همزمان
    setEditingPopup(popup)
    setTitle(popup.title || "")
    setPopupType(popupTypeValue)
    setPopupInput(inputData)
    onOpen()
  }
  const handlePopupTypeChange = (event) => {
    const newType = event.target.value
    setPopupType(newType)
    // پاک کردن popupInput وقتی نوع تغییر می‌کند
    if (!editingPopup) {
      setPopupInput({})
    }
  }

  const handleImageUpload = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    
    const file = acceptedFiles[0];
    setUploadingImage(true);
    
    const progressCallback = (percent) => {
      // می‌توانید progress را نمایش دهید
    };

    uploadFile(file, progressCallback)
      .then((result) => {
        const filePath = result?.data?.path || result?.path || result?.data?.file?.path || result?.data?.filePath;
        if (filePath) {
          // اطمینان از اینکه مسیر به فرمت صحیح است
          const normalizedPath = filePath.startsWith('/') ? filePath.substring(1) : filePath;
          setPopupInput(prev => ({
            ...prev,
            "image-file": normalizedPath
          }));
          toast.success("فایل تصویر با موفقیت آپلود شد", {
            position: "bottom-right"
          });
        } else {
          console.log("Response format:", result);
          toast.error("خطا در دریافت مسیر فایل", {
            position: "bottom-right"
          });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err?.response?.data?.message?.pr) {
          toast.error(err.response.data.message.pr, {
            position: "bottom-right"
          });
        } else {
          toast.error("خطا در آپلود فایل تصویر", {
            position: "bottom-right"
          });
        }
      })
      .finally(() => {
        setUploadingImage(false);
      });
  }, []);

  const handleVideoUpload = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    
    const file = acceptedFiles[0];
    setUploadingVideo(true);
    
    const progressCallback = (percent) => {
      // می‌توانید progress را نمایش دهید
    };

    uploadFile(file, progressCallback)
      .then((result) => {
        const filePath = result?.data?.path || result?.path || result?.data?.file?.path || result?.data?.filePath;
        if (filePath) {
          // اطمینان از اینکه مسیر به فرمت صحیح است
          const normalizedPath = filePath.startsWith('/') ? filePath.substring(1) : filePath;
          setPopupInput(prev => ({
            ...prev,
            "video-file": normalizedPath
          }));
          toast.success("فایل ویدیو با موفقیت آپلود شد", {
            position: "bottom-right"
          });
        } else {
          console.log("Response format:", result);
          toast.error("خطا در دریافت مسیر فایل", {
            position: "bottom-right"
          });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err?.response?.data?.message?.pr) {
          toast.error(err.response.data.message.pr, {
            position: "bottom-right"
          });
        } else {
          toast.error("خطا در آپلود فایل ویدیو", {
            position: "bottom-right"
          });
        }
      })
      .finally(() => {
        setUploadingVideo(false);
      });
  }, []);

  const handleSoundUpload = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    
    const file = acceptedFiles[0];
    setUploadingSound(true);
    
    const progressCallback = (percent) => {
      // می‌توانید progress را نمایش دهید
    };

    uploadFile(file, progressCallback)
      .then((result) => {
        const filePath = result?.data?.path || result?.path || result?.data?.file?.path || result?.data?.filePath;
        if (filePath) {
          // اطمینان از اینکه مسیر به فرمت صحیح است
          const normalizedPath = filePath.startsWith('/') ? filePath.substring(1) : filePath;
          setPopupInput(prev => ({
            ...prev,
            "sound-file": normalizedPath
          }));
          toast.success("فایل صوتی با موفقیت آپلود شد", {
            position: "bottom-right"
          });
        } else {
          console.log("Response format:", result);
          toast.error("خطا در دریافت مسیر فایل", {
            position: "bottom-right"
          });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err?.response?.data?.message?.pr) {
          toast.error(err.response.data.message.pr, {
            position: "bottom-right"
          });
        } else {
          toast.error("خطا در آپلود فایل صوتی", {
            position: "bottom-right"
          });
        }
      })
      .finally(() => {
        setUploadingSound(false);
      });
  }, []);

  // تابع برای تبدیل مسیر فایل به URL
  const getFileUrl = (filePath) => {
    if (!filePath) return null;
    
    // اگر مسیر با / شروع شده باشد، آن را حذف کن
    let cleanPath = filePath.startsWith('/') ? filePath.substring(1) : filePath;
    
    // تبدیل مسیر به فرمت URL
    let url = cleanPath;
    if (cleanPath.startsWith("upload/user/")) {
      url = cleanPath.replace("upload/user/", "assets/users/");
    } else if (cleanPath.startsWith("assets/users/")) {
      url = cleanPath;
    } else if (!cleanPath.startsWith("http")) {
      // اگر مسیر نسبی است و با upload/user شروع نمی‌شود، فرض می‌کنیم که باید assets/users باشد
      url = `assets/users/${cleanPath}`;
    }
    
    // اگر URL کامل است (با http شروع می‌شود)، همان را برگردان
    if (url.startsWith("http")) {
      return url;
    }
    
    // در غیر این صورت، با host ترکیب کن
    return `${config.host}/${url}`;
  };

  // کامپوننت Dropzone برای آپلود تصویر
  const ImageUploadDropzone = ({ value, uploading, onUpload }) => {
    const ChakraLinkComponent = Link;
    const dropzone = useDropzone({
      onDrop: onUpload,
      accept: {
        'image/*': ['.jpg', '.jpeg', '.png', '.gif', '.webp']
      },
      maxFiles: 1,
      multiple: false,
      disabled: uploading
    });

    const fileUrl = value ? getFileUrl(value) : null;

    return (
      <Box>
        <Box
          {...dropzone.getRootProps()}
          border="2px dashed"
          borderColor={dropzone.isDragActive ? "blue.400" : "gray.300"}
          borderRadius="md"
          p="20px"
          textAlign="center"
          cursor={uploading ? "not-allowed" : "pointer"}
          bg={dropzone.isDragActive ? "blue.50" : "transparent"}
          opacity={uploading ? 0.6 : 1}
          transition="all 0.2s"
          _hover={!uploading ? { borderColor: "blue.400", bg: "blue.50" } : {}}
        >
          <input {...dropzone.getInputProps()} />
          {uploading ? (
            <Text fontSize="xs" color="blue.500">
              در حال آپلود...
            </Text>
          ) : value ? (
            <Text fontSize="xs" color="green.500">
              فایل انتخاب شده: {value.split('/').pop()}
            </Text>
          ) : (
            <Text fontSize="xs" color="gray.500">
              {dropzone.isDragActive
                ? "فایل را اینجا رها کنید"
                : "فایل تصویر را اینجا بکشید یا کلیک کنید"}
            </Text>
          )}
        </Box>
        {fileUrl && !uploading && (
          <Box mt="15px" textAlign="center">
            <Box display="flex" justifyContent="center" alignItems="center">
              <Image 
                src={fileUrl} 
                alt="تصویر انتخاب شده" 
                maxH="200px" 
                maxW="100%"
                borderRadius="md"
                border="1px solid"
                borderColor={borderColor}
              />
            </Box>
            <ChakraLinkComponent href={fileUrl} target="_blank" fontSize="xs" color="blue.500" mt="10px" display="block">
              مشاهده تصویر در تب جدید
            </ChakraLinkComponent>
          </Box>
        )}
      </Box>
    );
  };

  // کامپوننت Dropzone برای آپلود ویدیو
  const VideoUploadDropzone = ({ value, uploading, onUpload }) => {
    const ChakraLinkComponent = Link;
    const dropzone = useDropzone({
      onDrop: onUpload,
      accept: {
        'video/*': ['.mp4', '.webm', '.ogg']
      },
      maxFiles: 1,
      multiple: false,
      disabled: uploading
    });

    const fileUrl = value ? getFileUrl(value) : null;

    return (
      <Box>
        <Box
          {...dropzone.getRootProps()}
          border="2px dashed"
          borderColor={dropzone.isDragActive ? "blue.400" : "gray.300"}
          borderRadius="md"
          p="20px"
          textAlign="center"
          cursor={uploading ? "not-allowed" : "pointer"}
          bg={dropzone.isDragActive ? "blue.50" : "transparent"}
          opacity={uploading ? 0.6 : 1}
          transition="all 0.2s"
          _hover={!uploading ? { borderColor: "blue.400", bg: "blue.50" } : {}}
        >
          <input {...dropzone.getInputProps()} />
          {uploading ? (
            <Text fontSize="xs" color="blue.500">
              در حال آپلود...
            </Text>
          ) : value ? (
            <Text fontSize="xs" color="green.500">
              فایل انتخاب شده: {value.split('/').pop()}
            </Text>
          ) : (
            <Text fontSize="xs" color="gray.500">
              {dropzone.isDragActive
                ? "فایل را اینجا رها کنید"
                : "فایل ویدیو را اینجا بکشید یا کلیک کنید"}
            </Text>
          )}
        </Box>
        {fileUrl && !uploading && (
          <Box mt="15px" textAlign="center">
            <Box display="flex" justifyContent="center" alignItems="center">
              <video 
                src={fileUrl} 
                controls 
                style={{ maxHeight: "200px", maxWidth: "100%", borderRadius: "8px", margin: "0 auto" }}
              />
            </Box>
            <ChakraLinkComponent href={fileUrl} target="_blank" fontSize="xs" color="blue.500" mt="10px" display="block">
              مشاهده ویدیو در تب جدید
            </ChakraLinkComponent>
          </Box>
        )}
      </Box>
    );
  };

  // کامپوننت Dropzone برای آپلود صدا
  const SoundUploadDropzone = ({ value, uploading, onUpload }) => {
    const ChakraLinkComponent = Link;
    const dropzone = useDropzone({
      onDrop: onUpload,
      accept: {
        'audio/*': ['.mp3', '.wav', '.ogg', '.m4a']
      },
      maxFiles: 1,
      multiple: false,
      disabled: uploading
    });

    const fileUrl = value ? getFileUrl(value) : null;

    return (
      <Box>
        <Box
          {...dropzone.getRootProps()}
          border="2px dashed"
          borderColor={dropzone.isDragActive ? "blue.400" : "gray.300"}
          borderRadius="md"
          p="20px"
          textAlign="center"
          cursor={uploading ? "not-allowed" : "pointer"}
          bg={dropzone.isDragActive ? "blue.50" : "transparent"}
          opacity={uploading ? 0.6 : 1}
          transition="all 0.2s"
          _hover={!uploading ? { borderColor: "blue.400", bg: "blue.50" } : {}}
        >
          <input {...dropzone.getInputProps()} />
          {uploading ? (
            <Text fontSize="xs" color="blue.500">
              در حال آپلود...
            </Text>
          ) : value ? (
            <Text fontSize="xs" color="green.500">
              فایل انتخاب شده: {value.split('/').pop()}
            </Text>
          ) : (
            <Text fontSize="xs" color="gray.500">
              {dropzone.isDragActive
                ? "فایل را اینجا رها کنید"
                : "فایل صوتی را اینجا بکشید یا کلیک کنید"}
            </Text>
          )}
        </Box>
        {fileUrl && !uploading && (
          <Box mt="15px" textAlign="center">
            <Box display="flex" justifyContent="center" alignItems="center">
              <audio 
                src={fileUrl} 
                controls 
                style={{ width: "100%", maxWidth: "400px", borderRadius: "8px" }}
              />
            </Box>
            <ChakraLinkComponent href={fileUrl} target="_blank" fontSize="xs" color="blue.500" mt="10px" display="block">
              مشاهده فایل صوتی در تب جدید
            </ChakraLinkComponent>
          </Box>
        )}
      </Box>
    );
  };

  const handleTourChanges = (event) => {
    setSelectedTour(event.target.value)
  }
  const handleChanges = (event, name) => {
    setPopupInput(prev => ({
      ...prev,
      [event.target.name]: event.target.value
    }))
  }
  const openPopupCreate = function () {
    resetPopupForm()
    onOpen()
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardHeader>
          <Flex justify='space-between' align='center' mb='1rem' w='100%'>
            <Text fontSize='md' color={textColor} fontWeight='bold'>
              پاپ آپ‌ها
            </Text>
            <Button
              onClick={openPopupCreate}
              variant='outlined'
              color={colorMode === "dark" && "white"}
              _hover={colorMode === "dark" && "none"}
              borderColor={colorMode === "dark" && "white"}
              minW='110px'
              maxH='35px'>
              ساخت پاپ آپ
            </Button>
          </Flex>
        </CardHeader>
        <CardBody>

          <Table variant="simple" color={textColor}>
            <Thead>
              <Tr my=".8rem" pl="0px" color="gray.400" >
                <Th pl="0px" borderColor={borderColor} color="gray.400" >
                  عنوان
                </Th>
                {
                  //<Th hidden={address} borderColor={borderColor} color="gray.400" >نمایشگاه</Th>
                }
                <Th borderColor={borderColor} color="gray.400" >تاریخ ایجاد</Th>
                <Th hidden={true} borderColor={borderColor} color="gray.400"></Th>
                <Th borderColor={borderColor}></Th>
              </Tr>
            </Thead>

            {
              (isLoading) ? (
                <tbody class='loading'>
                  <tr>
                    <td class="td-2"><span class='box'></span></td>
                    <td hidden={address} class="td-3"><span></span></td>
                    <td class="td-3"><span></span></td>
                    <td class="td-2" hidden={true} ><span class='box'></span></td>
                    <td class="td-2"><span class='box'></span></td>
                  </tr>
                  <tr>
                    <td class="td-2"><span class='box'></span></td>
                    <td hidden={address} class="td-3"><span></span></td>
                    <td class="td-3"><span></span></td>
                    <td class="td-2" hidden={true} ><span class='box'></span></td>
                    <td class="td-2"><span class='box'></span></td>
                  </tr>
                </tbody>
              ) :
                (
                  <Tbody>
                    {tablesTableData?.length > 0 ?
                      tablesTableData.map((row, index, arr) => {
                        let isLast = (index === arr.length - 1 ? true : false)
                        let date = (moment(row.createdAt).format('jYYYY-jM-jD HH:mm:ss'))
                        return (
                          <>
                            <Tr>
                              <Td
                                minWidth={{ sm: "250px" }}
                                pl="0px"
                                borderColor={borderColor}
                                borderBottom={isLast ? "none" : null}
                              >
                                <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
                                  <IconBox ml={"20px"} as='box' >
                                    <Icon h={"25px"} w={"25px"} color={titleColor} as={RiLayoutTop2Fill} />
                                  </IconBox>
                                  <Flex direction="column">
                                    <Text
                                      fontSize="sm"
                                      color={titleColor}
                                      fontWeight="bold"
                                      minWidth="100%"
                                    >
                                      {row.title}
                                    </Text>
                                  </Flex>
                                </Flex>
                              </Td>
                              {
                    /*<Td hidden={address} borderColor={borderColor} borderBottom={isLast ? "none" : null}>
                                <Text fontSize="xs" color={textColor} dir="ltr" textAlign="right" pb=".5rem">
                                  {tours && tours.map(item => { return item.address == row.address ? item.address : "" })}
                                </Text>
                              </Td>
                    */}
                              <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
                                <Text fontSize="xs" color={textColor} dir="ltr" textAlign="right" pb=".5rem">
                                  {date}
                                </Text>
                              </Td>
                              <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
                                <Button
                                  onClick={() => openEditPopup(row)}
                                  color="blue.400"
                                  fontSize="xs"
                                  minW='110px'
                                  maxH='35px'>
                                  ویرایش
                                </Button>
                              </Td>
                              <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
                                <Button
                                  onClick={() => { setSelectedRow(row); onDeleteOpen() }}
                                  color="red.400"
                                  fontSize="xs"
                                  minW='110px'
                                  maxH='35px'>
                                  حذف
                                </Button>
                              </Td>
                            </Tr>

                          </>
                        );
                      })
                      : <><tr><td colspan="6">
                        <Flex p="100px" align='center' w='100%'>
                          <IconBox as='box' w={"100%"} >
                            <Icon h={"150px"} w={"150px"} color={iconBlue} as={RiPlantLine} />
                          </IconBox>

                        </Flex>
                      </td></tr>
                      </>
                    }

                  </Tbody>
                )
            }

          </Table>
        </CardBody>
      </Card>
      <Modal isOpen={isOpen} onClose={() => { onClose(); resetPopupForm(); }}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center" >{editingPopup ? "ویرایش پاپ آپ" : "ساخت پاپ آپ جدید"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Scrollbars dir="ltr" autoHeightMin={0}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              hideTracksWhenNotNeeded={true}
              autoHeight
              autoHeightMax={490}
            >
              <Grid dir="rtl" mr={"20px"} ml={"10px"} mb="10px">
                  {/*

                <FormControl hidden={address} w='100%' mt={"20px"} id="video-files-input">
                  <FormLabel fontSize={"xs"}>نمایشگاه</FormLabel>
                  <Select w={"100%"} textAlign={"right"} dir={"ltr"} fontSize="xs"
                    onChange={event => handleTourChanges(event)}>
                    <option dir={"rtl"} value={""}>{"انتخاب کنید"}</option>
                    {tours && tours.map((row, idx) => {
                      return (
                        <option dir={"rtl"} value={row.address}>{row.title}</option>
                      );
                    })}
                  </Select>
                </FormControl>
                  */
                  }
                <Grid /*hidden={selectedTour == ""}*/>
                  <FormControl mt={"20px"} id="title">
                    <FormLabel fontSize={"xs"} >عنوان (فارسی)</FormLabel>
                    <Input fontSize={"xs"} value={title} onChange={e => setTitle(e.target.value)} type="text" />
                  </FormControl>
                  <FormControl w='100%' mt={"20px"} id="popup-type-input">
                    <FormLabel fontSize={"xs"}  >نوع</FormLabel>
                    <Select w={"100%"} textAlign={"right"} dir={"ltr"} fontSize="xs" name="popup-type"
                      value={popupType}
                      onChange={event => handlePopupTypeChange(event)}>
                      {types.map((row, idx) => {
                        return (
                          <option key={idx} dir={"rtl"} value={row.value}>{row.title}</option>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <Grid hidden={popupType != "gallery"}>
                    <PopupGallery files={files} popups={options} popupInput={popupInput} setPopupInput={setPopupInput} />
                  </Grid>
                  <Grid hidden={popupType != "list"}>
                    <PopupList files={files} popups={options} popupInput={popupInput} setPopupInput={setPopupInput} />
                  </Grid>
                  <Grid hidden={popupType != "googleform"}>
                    <FormControl mt={"20px"} id="googleform">
                      <FormLabel fontSize={"xs"} >لینک</FormLabel>
                      <Input fontSize={"xs"} placeholder="https://docs.google.com/forms/" dir="ltr" name="googleform-href" value={popupInput["googleform-href"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                  </Grid>
                  <Grid hidden={popupType != "iframe"}>
                    <FormControl mt={"20px"} id="iframe">
                      <FormLabel fontSize={"xs"} >لینک</FormLabel>
                      <Input fontSize={"xs"} placeholder="https://tpan.ir" dir="ltr" name="iframe-href" value={popupInput["iframe-href"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                  </Grid>
                  <Grid hidden={popupType.split("-")[1] != "video"}>
                    <FormControl mt={"20px"} id="video-text">
                      <FormLabel fontSize={"xs"} >متن</FormLabel>
                      <Textarea fontSize={"xs"} name="video-text" onChange={event => handleChanges(event)} type="text" h="auto" autoGrow={10} rows={5} height="auto" value={popupInput["video-text"]} placeholder={""} />
                    </FormControl>
                    <FormControl w='100%' mt={"20px"} id="video-files-input">
                      <FormLabel fontSize={"xs"} >فایل ویدیو</FormLabel>
                      <VideoUploadDropzone 
                        value={popupInput["video-file"]}
                        uploading={uploadingVideo}
                        onUpload={handleVideoUpload}
                      />
                    </FormControl>
                    <FormControl mt={"20px"} id="video-title">
                      <FormLabel fontSize={"xs"} >عنوان دکمه (اختیاری)</FormLabel>
                      <Input fontSize={"xs"} name="video-title" value={popupInput["video-title"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                    <FormControl mt={"20px"} id="video-link">
                      <FormLabel fontSize={"xs"} >لینک دکمه (اختیاری)</FormLabel>
                      <Input fontSize={"xs"} dir="ltr" name="video-link" value={popupInput["video-link"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                  </Grid>
                  <Grid hidden={popupType.split("-")[1] != "sound"}>
                    <FormControl mt={"20px"} id="sound-text">
                      <FormLabel fontSize={"xs"} >متن</FormLabel>
                      <Textarea fontSize={"xs"} name="sound-text" onChange={event => handleChanges(event)} type="text" h="auto" autoGrow={10} rows={5} height="auto" value={popupInput["sound-text"]} placeholder={""} />
                    </FormControl>
                    <FormControl w='100%' mt={"20px"} id="sound-files-input">
                      <FormLabel fontSize={"xs"} >فایل صدا</FormLabel>
                      <SoundUploadDropzone 
                        value={popupInput["sound-file"]}
                        uploading={uploadingSound}
                        onUpload={handleSoundUpload}
                      />
                    </FormControl>
                    <FormControl mt={"20px"} id="sound-title">
                      <FormLabel fontSize={"xs"} >عنوان دکمه (اختیاری)</FormLabel>
                      <Input fontSize={"xs"} name="sound-title" value={popupInput["sound-title"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                    <FormControl mt={"20px"} id="sound-link">
                      <FormLabel fontSize={"xs"} >لینک دکمه (اختیاری)</FormLabel>
                      <Input fontSize={"xs"} dir="ltr" name="sound-link" value={popupInput["sound-link"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                  </Grid>
                  <Grid hidden={popupType.split("-")[1] != "text"}>
                    <FormControl mt={"20px"} id="text-text">
                      <FormLabel fontSize={"xs"} >متن</FormLabel>
                      <Textarea fontSize={"xs"} name="text-text" onChange={event => handleChanges(event)} type="text" h="auto" autoGrow={10} rows={5} height="auto" value={popupInput["text-text"]} placeholder={""} />
                    </FormControl>
                    <FormControl mt={"20px"} id="text-title">
                      <FormLabel fontSize={"xs"} >عنوان دکمه (اختیاری)</FormLabel>
                      <Input fontSize={"xs"} name="text-title" value={popupInput["text-title"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                    <FormControl mt={"20px"} id="text-link">
                      <FormLabel fontSize={"xs"} >لینک دکمه (اختیاری)</FormLabel>
                      <Input fontSize={"xs"} dir="ltr" name="text-link" value={popupInput["text-link"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                  </Grid>
                  <Grid hidden={popupType.split("-")[1] != "image"}>
                    <FormControl mt={"20px"} id="image-text">
                      <FormLabel fontSize={"xs"} >متن</FormLabel>
                      <Textarea fontSize={"xs"} name="image-text" onChange={event => handleChanges(event)} type="text" h="auto" autoGrow={10} rows={5} height="auto" value={popupInput["image-text"]} placeholder={""} />
                    </FormControl>
                    <FormControl w='100%' mt={"20px"} id="image-files-input">
                      <FormLabel fontSize={"xs"} >فایل تصویر</FormLabel>
                      <ImageUploadDropzone 
                        value={popupInput["image-file"]}
                        uploading={uploadingImage}
                        onUpload={handleImageUpload}
                      />
                    </FormControl>
                    <FormControl mt={"20px"} id="image-alt">
                      <FormLabel fontSize={"xs"} >توضیحات تصویر</FormLabel>
                      <Input fontSize={"xs"} name="image-alt" value={popupInput["image-alt"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                    <FormControl mt={"20px"} id="image-title">
                      <FormLabel fontSize={"xs"} >عنوان دکمه (اختیاری)</FormLabel>
                      <Input fontSize={"xs"} name="image-title" value={popupInput["image-title"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                    <FormControl mt={"20px"} id="image-link">
                      <FormLabel fontSize={"xs"} >لینک دکمه (اختیاری)</FormLabel>
                      <Input fontSize={"xs"} dir="ltr" name="image-link" value={popupInput["image-link"]} onChange={event => handleChanges(event)} type="text" />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Scrollbars>
          </ModalBody>
          <ModalFooter>
            <NiceButton
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isCreateLoading}
              onClick={createPopupAction}
              fontSize='xs'
              w="100px"
            >
              ثبت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={isDeleteOpen}
        onClose={onDeleteClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">حذف پاپ آپ</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            پاپ آپ به صورت بی بازگشت حذف خواهد شد، آیا مایل به حذف هستید؟
            توجه داشته باشید که ماکرها و منوهایی که به این پاپ آپ اشاره کرده اند، دچار مشکل خواهند شد.
          </ModalBody>
          <ModalFooter>
            <Button fontSize='xs' onClick={onDeleteClose}>خیر</Button>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isDeleteLoading}
              onClick={Delete}
              fontSize='xs'
              w="100px">
              بله
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default Popups;
